import styled, { css } from 'styled-components';
import { inject } from 'mobx-react';
import chroma from 'chroma-js';

import { institutionLogoWidth } from 'js/config/style';

const animatedBackground = css`
  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: ${({ bankAccount }) =>
    `linear-gradient(to right, ${bankAccount.institution_color.brighten(1)} 8%, ${
      bankAccount.institution_color
    } 18%, ${bankAccount.institution_color.brighten(1)} 33%)`};
  background-size: 1000px 104px;
`;

const colorStyle = css`
  background: ${({ bankAccount }) => bankAccount.institution_color};
  color: white;
  padding-left: 1rem;
  border-radius: 0 0.25rem 0.25rem 0;
  border-left: ${({ bankAccount }) => `1px solid ${bankAccount.institution_color.darken()}`};
`;

export default inject('bankAccount')(styled.div`
  position: relative;
  ${({ bankAccount }) => bankAccount.institution_color && colorStyle}
  ${({ isBusy }) => isBusy && animatedBackground}
  border: 1px solid ${({ bankAccount }) => chroma(bankAccount.institution_color).darken()};
  border-radius: 0.25rem;
  min-height: ${({ height }) => height}rem;
  display: flex;
  align-items: bottom;
  justify-content: center;
`);
